import createStore from './reducers/index.js';
let storeObject = createStore();
export default storeObject;

